// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-61626696] {\n  display: flex;\n}\n.el-row[data-v-61626696] {\n  margin: 0!important;\n}\n[data-v-61626696] .el-form-item__label {\n  width: 125px;\n}\n.el-col[data-v-61626696] {\n  padding: 0!important;\n}\n.ml20[data-v-61626696] {\n  margin-left: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
